"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.hasAuthToken = exports.hasAuthParams = exports.getAuthTokenParam = void 0;
var TOKEN_RE = /[?&]authToken=([^&]+)/;
var CODE_RE = /[?&]code=[^&]+/;
var STATE_RE = /[?&]state=[^&]+/;
var ERROR_RE = /[?&]error=[^&]+/;

var hasAuthParams = function hasAuthParams() {
  var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
  return (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) && STATE_RE.test(searchParams);
};

exports.hasAuthParams = hasAuthParams;

var hasAuthToken = function hasAuthToken() {
  var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
  return TOKEN_RE.test(searchParams);
};

exports.hasAuthToken = hasAuthToken;

var getAuthTokenParam = function getAuthTokenParam() {
  var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
  return searchParams.match(TOKEN_RE)[1];
};

exports.getAuthTokenParam = getAuthTokenParam;